import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import { UitkButton, UitkButtonTheme } from './uitk-button.esm.js';

var UitkPagingButton = /** @class */ (function (_super) {
    __extends(UitkPagingButton, _super);
    function UitkPagingButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkPagingButton.prototype.render = function () {
        var _a;
        var _b = this.props, icon = _b.icon, iconId = _b.iconId, iconTitle = _b.iconTitle, children = _b.children, props = __rest(_b, ["icon", "iconId", "iconTitle", "children"]);
        var cssClassNames = classNames(props.className, UitkButton.baseClassName + "-paging", (_a = {},
            _a[UitkButton.baseClassName + "-paging-overlay"] = props.pagingOverlay || props.theme === UitkButtonTheme.TRANSPARENT,
            _a));
        return (React.createElement(UitkButton, __assign({}, props, { className: cssClassNames }),
            icon && React.createElement(UitkIcon, { name: icon, id: iconId, title: iconTitle }),
            children || null));
    };
    UitkPagingButton.displayName = 'UitkPagingButton';
    return UitkPagingButton;
}(React.Component));

export { UitkPagingButton };
